import { MessageCircle } from "lucide-react";
import { BRAND } from "@/data/content";

const WhatsAppFloat = () => {
  const link = `${BRAND.whatsapp}?text=${BRAND.whatsappText}`;
  return (
    <a
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="floating-whatsapp-btn"
      aria-label="Chat with INC. Cleaning on WhatsApp"
      className="fixed bottom-6 right-6 z-50 size-14 sm:size-16 grid place-items-center bg-[#25D366] hover:bg-[#1ebe5b] text-white rounded-full shadow-xl wa-pulse transition-colors"
    >
      <MessageCircle className="size-6 sm:size-7" />
    </a>
  );
};

export default WhatsAppFloat;
